import { render, staticRenderFns } from "./child-ring-cell.vue?vue&type=template&id=24ccec7a&scoped=true"
import script from "./child-ring-cell.vue?vue&type=script&lang=js"
export * from "./child-ring-cell.vue?vue&type=script&lang=js"
import style0 from "./child-ring-cell.vue?vue&type=style&index=0&id=24ccec7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ccec7a",
  null
  
)

export default component.exports